import React from 'react';

export default function Navbar({ theme, setTheme }) {
  return (
    <nav className="navbar">
      <a href="#/" className="navbar-brand">celest</a>
      <button
        type="button"
        className="theme-btn"
        aria-label={theme === 'dark' ? 'switch to light theme' : 'switch to dark theme'}
        title={theme === 'dark' ? 'switch to light theme' : 'switch to dark theme'}
        onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
      >
        <span aria-hidden="true">{theme === 'dark' ? '☀' : '☾'}</span>
      </button>
      <div className="navbar-links">
        <a href="#/quickstart">quickstart</a>
        <a href="#/api">api</a>
        <a href="#/stdlib">stdlib</a>
        <a href="https://github.com/Alex000291/celestc" target="_blank" rel="noreferrer">github</a>
      </div>
    </nav>
  );
}